const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* DAYBLIND 9 Oct 2026: bundle/offer buttons set aria-busy then redirect to /cart.
   When the shopper comes back (Back button, back/forward cache) the page is restored
   with the button still busy = greyed out and unclickable. Reset it on every pageshow. */
window.addEventListener('pageshow', function () {
  document.querySelectorAll('.db-bb__add[aria-busy], .db-bcard__btn[aria-busy], .db-byo__add[aria-busy], .db-pack__add[aria-busy], .db-offer[aria-busy]').forEach(function (b) {
    b.removeAttribute('aria-busy');
  });
});
